import React from 'react';
import { motion } from 'framer-motion';
import Section from '../../components/ui/Section';

const MirrorOfTruth = () => (
  <Section className="bg-darker border-t border-white/5 relative overflow-hidden">
    <div className="absolute top-0 right-0 w-1/2 h-full bg-gold/5 blur-[150px] rounded-full pointer-events-none transform translate-x-1/2" />

    <div className="max-w-4xl mx-auto relative z-10">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-100px' }}
        transition={{ duration: 1 }}
        className="text-center mb-16"
      >
        <h2 className="text-3xl md:text-5xl font-serif text-cream leading-tight">
          Die gläserne Decke der{' '}
          <span className="italic text-wine-light">Erschöpfung.</span>
        </h2>
      </motion.div>

      <div className="space-y-12">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-lg md:text-xl text-cream/70 font-light leading-relaxed space-y-6"
        >
          <p>
            Du funktionierst perfekt. Auf dem Papier bist du der Inbegriff von Erfolg.
            Du erreichst die Umsatzziele, führst das Team und setzt Strategien um.
            Doch unter der polierten Oberfläche spürst du das Gewicht einer Maske,
            die viel zu schwer zu tragen ist.
          </p>
          <p>
            Du hast ein Imperium aufgebaut – und es fühlt sich an wie ein goldener Käfig.
            Du arbeitest in einem ständigen Zustand des <em>Machens</em> – du drückst,
            strebst, zwingst und kontrollierst. Du hast den maskulinen Unternehmensplan
            verinnerlicht, der vorschreibt: Um mehr zu verdienen, musst du härter arbeiten.
            Um gesehen zu werden, musst du lauter schreien.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="relative p-10 md:p-14 border border-gold/20 bg-dark/50 backdrop-blur-md"
        >
          <div className="absolute -top-3 left-10 bg-darker px-4 text-gold tracking-widest uppercase text-xs">
            Die Wahrheit
          </div>
          <p className="text-2xl md:text-3xl font-serif text-cream italic leading-snug">
            "Wahre Sichtbarkeit entsteht nicht dadurch, dass du dich in den Algorithmus
            zwingst. Wahrer Wohlstand erfordert nicht deinen Burnout als Sicherheit.
            Es ist Zeit, vom{' '}
            <span className="text-gold font-bold">Machen</span> zum{' '}
            <span className="text-gold font-bold">Sein</span> überzugehen."
          </p>
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.5 }}
          className="text-lg md:text-xl text-cream/70 font-light leading-relaxed text-center"
        >
          Stell dir vor, dein Imperium läuft reibungslos, während du dich ausruhst.
          Hör auf die leise Stimme deiner Intuition, die den lauten Lärm der
          Branchenstandards ersetzt. Spüre, wie die dichte, schwere Energie des
          „Hustles" dein Nervensystem verlässt.
        </motion.p>
      </div>
    </div>
  </Section>
);

export default MirrorOfTruth;